import { shouldMockBatchAnswer as e } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerRunItem as t, createMockBatchAnswerRunResultResponse as n, createMockBatchAnswerRunsListResponse as r } from "./BatchAnswerEvaluationRuns.mocks.js";
import { API as i, Resource as a } from "@coveo/platform-client";
//#region src/resources/batch-answer/runs/BatchAnswerEvaluationRuns.resource.ts
var o = 2e3, s = 10, c = class c extends a {
	static {
		this.baseUrl = `/rest/organizations/${i.orgPlaceholder}/answer/v1/evaluations`;
	}
	list(t, n, i) {
		return e(i?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(r(i?.nbOfMockEntry ?? s, n?.page, n?.perPage));
			}, o);
		}) : this.api.get(this.buildPath(`${c.baseUrl}/${t.evaluationId}/runs`, n));
	}
	create(n, r, i) {
		return e(i?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(t(0));
			}, 200);
		}) : this.api.post(`${c.baseUrl}/${n.evaluationId}/runs`, r);
	}
	delete(t, n) {
		return e(n?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e();
			}, o);
		}) : this.api.delete(`${c.baseUrl}/${t.evaluationId}/runs/${t.runId}`);
	}
	updateNotes(t, n, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e();
			}, o);
		}) : this.api.put(`${c.baseUrl}/${t.evaluationId}/runs/${t.runId}/notes`, n);
	}
	results(t, r, i) {
		return e(i?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(n(s, r?.page, r?.perPage));
			}, o);
		}) : this.api.get(this.buildPath(`${c.baseUrl}/${t.evaluationId}/runs/results`, r));
	}
};
//#endregion
export { c as EvaluationRunResource };

//# sourceMappingURL=BatchAnswerEvaluationRuns.resource.js.map